import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MaintenanceService } from '../../../services/maintenance.service';
import { PermissionService } from '../../../services/permission.service';
import { BUILD } from '../../maintenances-tab/maintenances-routing.constants';
import { MaintenanceCardComponent } from '../../shared/card/maintenance-card/maintenance-card.component';
import { WidgetLoaderComponent } from '../../shared/widget/widget-loader/widget-loader.component';

@Component({
  selector: 'widget-maintenance',
  templateUrl: './widget-maintenance.component.html',
  styleUrls: ['./widget-maintenance.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatIcon,
    TranslatePipe,
    SlicePipe,
    RouterLink,
    MatTooltipModule,
    WidgetLoaderComponent,
    MaintenanceCardComponent,
  ],
})
export class WidgetMaintenanceComponent {
  public readonly BUILD = BUILD;
  private _maintenanceService = inject(MaintenanceService);
  public permissionService = inject(PermissionService);

  public $maintenances = this._maintenanceService.$valuesRecord;
  public $outOfDeadlinesMaintenances = this._maintenanceService.$outOfDeadlinesMaintenances;
}
